import { addStateEventListener, selectMetadata } from '@nx/state';

import { setProcedures } from '../connections/connectionsDuck';
import type { AppDispatch } from '../types';

export const initiateMetadataSync = (dispatch: AppDispatch) => {
  addStateEventListener('metadataUpdate', (listenerApi) => {
    const state = listenerApi.getState();

    const { procedures } = selectMetadata(state);
    dispatch(setProcedures(procedures));
  });
};
